import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  DropdownProps,
  DropdownRef,
} from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import useCallbackRef from 'hooks/useCallbackRef';
import ShareIcon from 'icons/Share.icon';
import classNames from 'classnames';
import { Button, Dropdown } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LinkedIn } from 'icons/linkedin.svg';
import MailopenIcon from 'icons/Mailopen.icon';
import { ReactComponent as Facebook } from 'icons/facebook.svg';
import LinkIcon from 'icons/Link.icon';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from 'react-share';
import useCopyToClipboard from 'hooks/useCopyToClipboard';

import './ShareButton.styles.scss';

type ShareButtonProps = {
  url: string;
  className?: string;
} & Partial<Omit<DropdownProps, 'ref'>>;

const ShareButton: ForwardRefRenderFunction<DropdownRef, ShareButtonProps> = (
  props,
  ref,
) => {
  const { t } = useTranslation();
  const {
    className,
    url,
    trigger = (
      <Button variant="link" icon={ShareIcon}>
        {t('share')}
      </Button>
    ),
    ...rest
  } = props;
  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  useImperativeHandle(ref, () => ({ ...dropdown }), [dropdown]);

  const classes = classNames('share-button-portal', className);

  const copyToClipboard = useCopyToClipboard();

  return (
    <Dropdown
      ref={dropdownRef}
      renderAsPortal
      portalClassName={classes}
      trigger={trigger}
      {...rest}
    >
      <div>
        <Button
          icon={LinkIcon}
          onClick={(e) => {
            copyToClipboard(e, url);
            dropdown.setIsOpen(false);
          }}
        />
        <p>{t('copyLink')}</p>
      </div>
      <div>
        <EmailShareButton url={url}>
          <MailopenIcon />
        </EmailShareButton>
        <p>{t('mail')}</p>
      </div>
      <div>
        <LinkedinShareButton url={url}>
          <LinkedIn />
        </LinkedinShareButton>
        <p>{t('linkedin')}</p>
      </div>
      <div>
        <FacebookShareButton url={url}>
          <Facebook />
        </FacebookShareButton>
        <p>{t('facebook')}</p>
      </div>
    </Dropdown>
  );
};

export default forwardRef(ShareButton);
